import React from "react";
import './Banner.css'

const Banner = () => {
  return (
      <div className="banner">
        <h2 className="banner-des"> Our stock center</h2>
      </div>
  );
};

export default Banner;
